/**
 * Entrada "1.123,44" | Salida "1123.44"
 * @param {*} str Valor importe por ej: "1.123,44"
 * @returns
 */
function parseImporte(str) {
  if (typeof str !== "string") return NaN;

  if (str.includes(",")) {
    return parseFloat(str.replace(/\./g, "").replace(",", "."));
  }

  return parseFloat(str);
}


/**
 * Formats a given value as Argentine Peso (ARS) currency string.
 *
 * @param {number|string} value - The value to format as ARS currency.
 * @returns {string} The formatted currency string in 'es-AR' locale, or an empty string if the input is not a valid number.
 */
function formatToARS(value) {
  const number = Number(value);
  if (isNaN(number)) return "";

  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2
  }).format(number);
}


/**
 * Normaliza un CUIT al formato con guiones XX-XXXXXXXX-X.
 * @param {string|number} value - CUIT con o sin guiones.
 * @returns {string} CUIT formateado o el valor original si no tiene 11 dígitos.
 */
function formatCuit(value) {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length !== 11) return String(value);
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10, 11)}`;
}

export { parseImporte, formatToARS, formatCuit };
